module.exports = __webpack_public_path__ + "media/tip4.4a198c8b.mp3";